import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';
import { TeamScorecard } from "@shared/models/team-scorecard";

const baseUrl = `${environment.apiBaseUrl}platform/teamscorecard`;
const adminUrl = `${environment.apiBaseUrl}platform/admin`;
const exportUrl = `${environment.apiBaseUrl}platform/export`;

@Injectable()
export class TeamScorecardService {
  scoreCardData: any;
  searchByValues: any;


  constructor(private http: HttpClient) { }

  getScoreCard(id: string): Observable<any> {

    return this.http.get<any>(`${baseUrl}/${id}/scorecard`);
  }

  setScorecard(data: any): void{
    this.scoreCardData = data;
  }

  getStoredScorecard(): any {
    return this.scoreCardData;
  }

  getResult(teamId: string, type: string, date?: any, page?:any, searchByValues?: any,sortedBy?: any, sortedOrder?: any): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    const body = {
      scoreCardWidgetType: type,
      page,
      searchByValues,
      sortedBy,
      sortedOrder,
    };

    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      params = params.append('toDate', date.toDate);
    }

    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }
    return this.http.post<any>(`${baseUrl}/${teamId}/scorecard`, body, {headers, params});
  }

  getReport(id: string): Observable<TeamScorecard.ReportModel> {
    return this.http.get<TeamScorecard.ReportModel>(`${baseUrl}/${id}/report/settings`);
  }

  syncSelections(): Observable<any> {
    return this.http.get<any>(`${baseUrl}/sync-selections`)
  }

  createReport(id: string, report: TeamScorecard.Report): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(`${baseUrl}/${id}/report/settings`, report);
  }

  updateReport(id: string, report: TeamScorecard.Report): Observable<any> {
    return this.http.put<any>(`${baseUrl}/${id}/report/settings`, report);
  }

  sendTestReport(teamId: string): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    return this.http.post<any>(`${baseUrl}/${teamId}/report/send`,{},{headers});
  }

  getSymptoms(id: string, period: string , filterTeams:string): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    const body = {
      period,
      teamFilterIds: filterTeams || [],
    };

    return this.http.post<any>(`${baseUrl}/${id}/symptoms`,body, {headers});

  }

  getSymptomsRootCause(teamId: string,symptom:any): Observable<any> {
    return this.http.get<any>(`${baseUrl}/${teamId}/symptoms/${symptom}/causes`, { })
  }

  getSymptomsDetectedTeams(teamId: string,symptom:any): Observable<any> {
    return this.http.get<any>(`${baseUrl}/${teamId}/symptoms/${symptom}/detection`, { })
  }

  getHealthCheck(teamId: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/${teamId}/symptoms/health-check`);
  }

  updateHealthCheck(teamId: string): Observable<any> {
    return this.http.put<any>(`${baseUrl}/${teamId}/symptoms/health-check`, { });
  }


  statusSymptoms(teamId: string, active: boolean, symptom: any): Observable<any> {
    let params = new HttpParams();

    if (active) {
      params = params.append('active', false);
    }

    if (symptom) {
      params = params.append('symptom', symptom);
    }

    return this.http.put<any>(`${baseUrl}/${teamId}/symptoms/active`, {  }, { params })
  }

  statusSymptoms2(teamId: string, active: boolean, symptom: any): Observable<any> {
    let params = new HttpParams();

    if (active) {
      params = params.append('active', true);
    }

    if (symptom) {
      params = params.append('symptom', symptom);
    }

    return this.http.put<any>(`${baseUrl}/${teamId}/symptoms/active`, {  }, { params })
  }
  getTabVisible(): Observable<any> {
    return this.http.get<any>(`${adminUrl}/features`);
  }

  contributorGetCommitWithSorting(teamId?: string, type?: string, date?: any, page?: any, searchByValues?: any, sorting?: any): Observable<any> {
    this.searchByValues = searchByValues;

    const body = {
      scoreCardWidgetType: type,
      page,
      searchByValues,
      sorting,
    };

    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      params = params.append('toDate', date.toDate);
    }

    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }

    return this.http.post<any>(`${baseUrl}/${teamId}/scorecard`, body, {headers, params});
  }

  getResultBySorting(teamId: string, type: string, date?: any, page?: any, searchByValues?: any, sorting?:any,memberSortresetPage?:boolean): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });
    const body = {
      scoreCardWidgetType: type,
      page,
      searchByValues,
      sorting,
      resetPage: memberSortresetPage
    };

    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      params = params.append('toDate', date.toDate);
    }

    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }

    return this.http.post<any>(`${baseUrl}/${teamId}/scorecard`, body, {headers, params});
  }

  exportTeam(teamId: string, date?: any, metricType?: string, sorting?: any, searchByValues?:any, showCount?:any, showLineChange?:any, millisecond?:any ): Observable<any> {
    const payload = {
      teamId,
      metricType,
      type: "EXCEL",
      from: '',
      to: '',
      sorting: sorting || null,
      searchByValues,
      showCount,
      showLineChange,
      millisecond
    };
    if (date && date.fromDate) {
      payload.from = date.fromDate;
      payload.to = date.toDate;
    }

    if (date && !date.fromDate) {
      payload.from = date;
    }
    return this.http.post(`${exportUrl}`, payload);
  }

  exportDeliveryReport(teamId: string, date?: any, metricType?: string,searchByValues?:any, millisecond?:any): Observable<any>{
    const payload = {
      teamId,
      metricType,
      type: "EXCEL",
      from:'',
      to: '',
      searchByValues,
      millisecond
    }
    if (date && date.fromDate) {
      payload.from = date.fromDate;
      payload.to = date.toDate;
    }

    if (date && !date.fromDate) {
      payload.from = date;
    }
    return this.http.post(`${exportUrl}`, payload);

  }

  exportAllocationsReport(teamId: string, metricType?: string,searchByValues?:any): Observable<any>{
    const payload = {
      teamId,
      metricType,
      type: "EXCEL",

      searchByValues,
    }

    return this.http.post(`${exportUrl}`, payload);

  }

  getExportDataListByTeam(teamId: string, metricType?: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('teamId', teamId);
    params = params.append('metricType', metricType);
    return this.http.get(`${exportUrl}`, {params});
  }

  downloadExportData(id) : Observable<HttpResponse<Blob>>{
    return this.http.get(`${exportUrl}/${id}`, { responseType: 'blob', observe: 'response' });
  }

  deleteDownloadExportData(id): Observable<any> {
    return this.http.delete(`${exportUrl}/${id}`);
  }

}
